export default __webpack_public_path__ + "static/cloudator-brochure-3d-outside-12657d838adc2a115642c3642e3f0448.jpg";